import { COLORS } from '@avalara/bat-apps-shared/constants';
import styled from 'styled-components';

import { RightColumn } from './sign-up';

export const HelpCenter = styled(RightColumn)`
  && {
    background: transparent;
    border: 1px solid ${COLORS.lightGray};
    border-top: 2px solid ${COLORS.lightGray};
  }

  img {
    margin: 0 auto;
  }

  button {
    margin-bottom: 0;
  }

  ${(props: { flex?: boolean }) =>
    props.flex
      ? `
    & > div {
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      > div {
        margin-right: 20px;

        &:last-child {
          margin-right: 0
        }
      }
    }`
      : ''}

  > div:last-child:not(:first-child){
    border: none;
    margin: 20px auto 0;
    text-align: center;
    width: auto;
  }
`;

export const VideoContainer = styled.div`
  && {
    p {
      color: ${COLORS.lighterMediumDarkGray};
    }
  }
`;

export const HelpCenterTitle = styled.h3`
  && {
    color: ${COLORS.lighterMediumDarkGray};
    font-size: 1.285em;
    line-height: 1.642em;

    + * {
      margin-top: 0;
    }
  }
`;

export const HelpCenterBlueTitle = styled.h4`
  && {
    font-size: 1.642em;
    color: ${COLORS.darkBlue};
    line-height: 2.071em;
  }
`;
